export const config = {
	    baseurl: "https://smartt.ttg.ec/api/v1",
	    baseMediaUrl: "https://smartt.ttg.ec",
	    einoviceUrl: "http://boleteriaselectronicas.ttg.ec"
}

